import * as React from 'react';
import { styled } from '@mui/system';
import { Tabs } from '@mui/base/Tabs';
import { TabPanel as BaseTabPanel } from '@mui/base/TabPanel';
import EventCard from "./EventCards";
import {getMonthName} from "../utils";
import Filters from "./Filters";
import {Box, Pagination, Typography} from '@mui/material';
import EventCardsMobile from "./EventCardsMobile";
import styles from "../styles/App.module.css";
import MainEvents from "./MainEvents";

export default function UnstyledTabsIntroduction({events, applyFilters, showLocation}) {
    const monthsAdded = { past: [], upcoming: [] };
    const pageSize = 10;
    const [pageUpcoming, setPageUpcoming] = React.useState(1);
    const [pagePast, setPagePast] = React.useState(1);
    const otherEventsRef = React.useRef(null);

    const handlePageNumberUpdate = React.useCallback((page, type) => {
        if (type === "upcoming") {
            setPageUpcoming(page);
        } else if (type === "past") {
            setPagePast(page);
        }
        scrollToOthers();
    }, []);

    const applyFiltersProxy = React.useCallback((filters) => {
        setPageUpcoming(1);
        setPagePast(1);
        applyFilters(filters)
    }, [applyFilters])

    const getMonth = (eventDate, type) => {
        const date = new Date(eventDate);
        const month = getMonthName(date.getMonth());
        if (monthsAdded[type].indexOf(month) > -1) {return <></>;}
        monthsAdded[type].push(month);
        const year = date.getFullYear();
        return (
            <Typography
                variant="h6"
                component="h4"
                style={{
                    fontWeight: 'bolder',
                    fontSize: "1.2rem",
                    marginBottom: "10px",
                }}
            >
                {`${month}, ${year}`}
            </Typography>
        )
    };

    const scrollToOthers = () => otherEventsRef.current.scrollIntoView();

    return (
        <>  
            <div className="four">
                <h1>Main <em>Events</em></h1>
            </div>
            <MainEvents />
            <div className="four" id="allevents" style={{marginBottom: "40px",paddingTop: "0px"}}>
                <h1>All <em>Events</em></h1>
            </div>

            <div className={styles.contentContainer} ref={otherEventsRef}>
                <Filters applyFilters={applyFiltersProxy}/>
                <Tabs defaultValue={0} className={styles.tabsContainer}>
                    <TabPanel value={0}>
                        {events.upcoming?.slice(pageSize * (pageUpcoming - 1), pageUpcoming * pageSize).map((event) => (
                            <React.Fragment key={event.id}>
                                <Box sx={{
                                    display: "block",
                                    width: {lg: "50%", md: "50%", sm: "80%", xs: "100%"},
                                    justifySelf: "center",
                                }}>
                                    {getMonth(event.startDate || event.date, "upcoming")}
                                </Box>
                                <EventCardsMobile event={event} showLocation={showLocation}/>
                                {/* <EventCard event={event} showLocation={showLocation}/> */}
                            </React.Fragment>
                        ))}
                        <Pagination
                            color="primary"
                            count={Math.ceil(events.upcoming.length / pageSize)}
                            page={pageUpcoming}
                            size="small"
                            style={{justifyItems: "center"}}
                            onChange={(e, page) => handlePageNumberUpdate(page, "upcoming")}
                        />
                    </TabPanel>
                    <TabPanel value={2}>
                        {events.past.slice(pageSize * (pagePast - 1), pagePast * pageSize).map((event) => (
                            <React.Fragment key={event.id}>
                                {getMonth(event.date, "past")}
                                <EventCardsMobile event={event} showLocation={showLocation}/>
                                <EventCard event={event} key={event.id} showLocation={showLocation}/>
                            </React.Fragment>
                        ))}
                        <Pagination
                            color="primary"
                            count={Math.ceil(events.past.length / pageSize)}
                            page={pagePast}
                            size="small"
                            style={{justifyItems: "center"}}
                            onChange={(e, page) => handlePageNumberUpdate(page, "past")}
                        />
                    </TabPanel>
                </Tabs>
            </div>
        </>
    );
}

const TabPanel = styled(BaseTabPanel)(
    () => `
  min-width: 300px;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  border-radius: 12px;
  `,
);